export function getEventSchema({
  name,
  description,
  startDate,
  endDate,
  url,
  image
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Event',
    name,
    description,
    startDate,
    endDate,
    eventAttendanceMode: 'https://schema.org/OnlineEventAttendanceMode',
    eventStatus: 'https://schema.org/EventScheduled',
    location: {
      '@type': 'VirtualLocation',
      url
    },
    image: image ? [image] : [],
    organizer: {
      '@type': 'Organization',
      name: 'Boltzmann Labs & ChemBio AI',
      url: 'https://chembioai.org'
    }
  };
}

